import { RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { Location, PopStateEvent } from "@angular/common";
import { Subscription, filter } from 'rxjs';
import { Router, NavigationEnd,NavigationStart } from '@angular/router';
import { TranslatorService } from './services/translator_service';
import { AuthService } from './services/auth.service';
import { LOCAL_STORAGE_KEYS } from './constants';
import {ResponsiveService} from './services/responsive.service';
import { ApiStore } from './web-services/api/api.store';
import { Sidebar } from './components/sidebar/sidebar';
import { Header } from './components/header/header';
import { Login } from './components/login/login';
import { RTLDivDirectiveDirective } from './directives/rtldiv-directive.directive';
import { AnalyticsService } from './analytics.service';
export let browserRefresh = false;


@Component({
  selector: 'app-root',
  imports: [RouterOutlet,Sidebar,Header,Login,RTLDivDirectiveDirective],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
	opened = true;
	fetchAlerts: any;
	mobileFlag : boolean = false;
	subscription: Subscription;
	lastPoppedUrl: any;
  	yScrollStack: any[] = [];
	logged_In : boolean = false;
	isBillingPage : boolean = false;
	
	constructor(
		private router: Router,
		private location: Location,
		private translator: TranslatorService,
		private authSrv: AuthService,
		private apiStore: ApiStore,
		private analytics: AnalyticsService,
		private responsiveService:ResponsiveService) { 
		  this.subscription = router.events.subscribe((event) => {
				if (event instanceof NavigationStart) {
					browserRefresh = !router.navigated;
					if(browserRefresh){
						sessionStorage.removeItem("chosenSites");
					}
					
				}
  			});
		}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
		this.analytics.init();

		this.getUserFromLocalStorage();

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		  ).subscribe((event: NavigationEnd) => {
			this.logged_In = this.isLoggedIn();
			this.isBillingPage = event.urlAfterRedirects.startsWith('/billing');
			if (event.urlAfterRedirects == '/login' && this.logged_In) {
				this.router.navigate(['/dashboard']);
			}
		});

		if(!this.mobileFlag){
			this.router.events.subscribe((evt) => {
				if (!(evt instanceof NavigationEnd)) {
					return;
				}
				const el = document.getElementById('super-container');
        if(el){
          el.scrollTop = 0;
        }
			});	
		}else{
			this.location.subscribe((ev:PopStateEvent) => {
				this.lastPoppedUrl = ev.url;
			});
			this.router.events.subscribe((ev:any) => {
				if (ev instanceof NavigationStart) {
					if (ev.url != this.lastPoppedUrl)
						this.yScrollStack.push(window.scrollY);
				} else if (ev instanceof NavigationEnd) {
					if (ev.url == this.lastPoppedUrl) {
						this.lastPoppedUrl = undefined;
						window.scrollTo(0, this.yScrollStack.pop());						
					} else
						window.scrollTo(0, 0);						
				}
			});
		}
		this.translator.initFromStoredLanguageOrDefault();
	}

	onResize(){
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
			this.mobileFlag = isMobile;
		});
	  }

	getUserFromLocalStorage = () => {
		if (this.authSrv.isTokenExists()) {
			const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER));
			this.apiStore.update({ user: user });
		}
	}

	isLoggedIn() {
		return this.authSrv.isTokenExists() && !this.isResetPassword();
	}

	isResetPassword() {
		const parsedUrl = window.location.href.split('/');
		if (parsedUrl.length > 1){
			if (parsedUrl[parsedUrl.length-2] === "resetPassword") {
				localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
				localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
				return true;
			}
		}
		return false;
	}
}
